import { DataTable } from 'simple-datatables';

export default () => {
  const dataTableElements = document.querySelectorAll('.datatable');
  window.dataTables = [];

  if (dataTableElements) {
    const dataTableOptions = {
      fixedHeight: false,
      destroy: true,
      searchable: false,
      paging: false,
      sortable: true,
      perPageSelect: false,
      nextPrev: false,
    };

    dataTableElements.forEach((element) => {
      if (element.dataset.datatablesSearch) {
        dataTableOptions.searchable = element.dataset.datatablesSearch === 'true';
      }
      if (element.dataset.datatablesPaging) {
        dataTableOptions.paging = true;
        dataTableOptions.perPage = parseInt(element.dataset.datatablesPaging, 10);
      }
      if (element.dataset.datatablesSortable) {
        dataTableOptions.sortable = element.dataset.datatablesSortable === 'true';
      }
      if (element.dataset.datatablesPerPageSelect) {
        dataTableOptions.perPageSelect = element.dataset.datatablesPerPageSelect === 'true';
      }
      if (element.dataset.datatablesFixedHeight) {
        dataTableOptions.fixedHeight = element.dataset.datatablesFixedHeight === 'true';
      }
      if (element.dataset.datatablesNextPrev) {
        dataTableOptions.nextPrev = element.dataset.datatablesNextPrev === 'true';
      }
      window.dataTables.push(new DataTable(element, dataTableOptions));
    });
  }
};
